import { render, staticRenderFns } from "./KeywordsAddPanel.vue?vue&type=template&id=37e1fa1a"
import script from "./KeywordsAddPanel.vue?vue&type=script&lang=js"
export * from "./KeywordsAddPanel.vue?vue&type=script&lang=js"
import style0 from "./KeywordsAddPanel.vue?vue&type=style&index=0&id=37e1fa1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports